import { Link } from 'react-router-dom';

interface QuietStateCardProps {
  eyebrow: string;
  title: string;
  description: string;
  ctaLabel?: string;
  ctaTo?: string;
}

export default function QuietStateCard({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaTo,
}: QuietStateCardProps) {
  return (
    <div className="glass-panel rounded-lg p-6 text-center">
      <p className="text-[10px] font-black uppercase tracking-widest text-gold-600 dark:text-gold-400 mb-2">
        {eyebrow}
      </p>
      <h3 className="text-xl font-black uppercase tracking-tight text-navy-900 dark:text-cream-50 mb-2">
        {title}
      </h3>
      <p className="text-sm text-navy-500 dark:text-cream-300 mb-4">{description}</p>
      {ctaLabel && ctaTo && (
        <Link
          to={ctaTo}
          className="inline-flex items-center justify-center rounded-lg bg-navy-700 px-4 py-2 text-xs font-black uppercase tracking-widest text-cream-50 transition hover:bg-navy-800"
        >
          {ctaLabel}
        </Link>
      )}
    </div>
  );
}
